module.exports = __webpack_public_path__ + "static/img/dsf_08.116d538.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dsfRobot/dsf_08.png
// module id = kwA3
// module chunks = 46